import { ApiBase } from '@/api/methods/ApiBase'

export namespace UserStudentsApi {
  /**
   * オプション引数(非必須のパラメータ)の型
   */
  type OptionParams = {
    /** 学年コード */
    gradeCode?: string
    /** 教室ID */
    branchId?: number
    /** コースID */
    courseId?: number
    /** クラスID */
    classId?: number
    /** 検索文字列 */
    searchText?: string
  }

  /**
   * 生徒一覧CSV取得API(id指定)
   *
   * @param ids 生徒IDの配列
   * @returns 生徒一覧
   */
  export async function getStudentsCsv(ids: number[]): Promise<Blob> {
    const params = {}
    if (ids.length !== 0) {
      Object.assign(params, { student_ids: ids })
    }
    return await ApiBase.get('export/csv/students', params)
  }

  /**
   * 生徒一覧CSV取得API
   *
   * @param options 非必須の絞り込み条件(gradeCode, branchId, courseId, classId, searchText)
   * @returns 生徒一覧
   */
  export async function getStudentsCsvAll(options: OptionParams): Promise<Blob> {
    const params = {}
    // 学年コードが存在すれば追加
    if (options.gradeCode) {
      Object.assign(params, { gradeCode: options.gradeCode })
    }
    // 教室IDが存在すれば追加
    if (options.branchId) {
      Object.assign(params, { branchId: options.branchId })
    }
    // コースIDが追加すれば追加
    if (options.courseId) {
      Object.assign(params, { courseId: options.courseId })
    }
    // クラスIDが存在すれば追加
    if (options.classId) {
      Object.assign(params, { classId: options.classId })
    }
    // 検索文字列があれば追加
    if (options.searchText) {
      Object.assign(params, { searchText: options.searchText })
    }
    return await ApiBase.get('export/csv/students/all', params)
  }
}
